<template>
    <div>
        <h2 class="h2">Příslušenství</h2>

        <accessory-picker-list
            ref="freeAccessories"
            label="Základní"
            :disabled-items="disabled"
            :accessory-data="freeAccessories"
            @change="onChange"
        />
        <accessory-picker-list
            ref="accessoriesToBuy"
            label="Doplňkové"
            :disabled-items="disabled"
            :accessory-data="accessoriesToBuy"
            @change="onChange"
        />

        <div v-if="freeAccessories.length === 0 && accessoriesToBuy.length === 0" class="info">
            <p class="info-text">Žádné příslušenství není nastaveno.</p>
        </div>

        <div class="elementary-section__controls button-fix">
            <custom-button @click="create" iconic class="m--t-1"><span icon create></span>Založit nové příslušenství
            </custom-button>
        </div>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import AccessoryPickerList from '@/modules/ProjectModule/modules/UnitModule/components/Accessory/AccessoryPickerList';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import CreateAccessoryOptionDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/Option/CreateAccessoryOptionDialog';

export default {
    name:       'AccessoryContainer',
    components: {CustomButton, AccessoryPickerList},
    computed:   {
        freeAccessories() {
            return this.$store.getters['projects/project/accessory/freeAccessories'];
        },
        accessoriesToBuy() {
            return this.$store.getters['projects/project/accessory/accessoriesToBuy'];
        }
    },
    data() {
        return {
            disabled: {},
        }
    },
    methods:    {
        create() {
            this.$modal.show(CreateAccessoryOptionDialog, {}, defaultModalParameters());
        },
        onChange(data) {
            const {accessoryId} = data;
            const freeAccessories = this.$refs.freeAccessories.$refs;
            const accessoriesToBuy = this.$refs.accessoriesToBuy.$refs;
            this.$store.dispatch('projects/project/units/unit/updateAccessory', data)
                .then(() => {
                    const accessoryRefKey = 'accessory-control-' + accessoryId;
                    if (freeAccessories.hasOwnProperty(accessoryRefKey)) {
                        freeAccessories[accessoryRefKey][0].successHighlight();
                    }
                    if (accessoriesToBuy.hasOwnProperty(accessoryRefKey)) {
                        accessoriesToBuy[accessoryRefKey][0].successHighlight();
                    }
                })
                .catch((message) => this.$dmv.notifyError(message))
        }
    }
}
</script>
